import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/login/login.component';
import { navigations } from './routes';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [authGuard], // 🔒 SECURE: Protect all admin routes
    data: { title: 'Home' },
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      ...navigations,
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/routes').then((m) => m.routes),
      },
      {
        path: 'security-settings',
        loadComponent: () =>
          import('./views/security-settings/security-settings.component').then(
            (m) => m.SecuritySettingsComponent,
          ),
        title: 'Security Settings',
      },
    ],
  },
  { path: '404', component: Page404Component },
  { path: '500', component: Page500Component },
  { path: 'login', component: LoginComponent },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./views/login/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
    title: 'Forgot Password',
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./views/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent,
      ),
    title: 'Access Denied',
  },
  { path: '**', redirectTo: 'users' },
];
